import {connect} from 'react-redux';
import {ProtocolScene as Component} from './ProtocolScene';

import {
    createPipette,
    //createSolution,
    createTipBox
} from '@learningblocks/protocol-redux/lib/Actions';

function mapStateToProps(state) {
  return {};
}

function mapDispatchToProps(dispatch) {
  return {
    createPipette,
    //createSolution,
    createTipBox
  };
}

export const ProtocolScene = connect(
  mapStateToProps,
  mapDispatchToProps
)(Component);
